import { render, staticRenderFns } from "./CommentsView.vue?vue&type=template&id=e80b897a&scoped=true"
import script from "./CommentsView.vue?vue&type=script&lang=js"
export * from "./CommentsView.vue?vue&type=script&lang=js"
import style0 from "./CommentsView.vue?vue&type=style&index=0&id=e80b897a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80b897a",
  null
  
)

export default component.exports